export function createSSEParser(onEvent) {
  var buffer = '';

  function flushFrame(frame) {
    if (!frame) return;
    var lines = frame.split('\n');
    var id = null;
    var event = 'message';
    var data = '';
    var hasField = false;
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      if (!line || line.charAt(0) === ':') continue;
      var colonIdx = line.indexOf(':');
      if (colonIdx === -1) continue;
      var field = line.substring(0, colonIdx);
      var value = line.substring(colonIdx + 1);
      if (value.charAt(0) === ' ') value = value.substring(1);
      if (field === 'id') { id = value; hasField = true; }
      else if (field === 'event') { event = value; hasField = true; }
      else if (field === 'data') { data = data ? data + '\n' + value : value; hasField = true; }
    }
    if (!hasField) return;
    var parsed;
    try {
      parsed = JSON.parse(data);
    } catch (e) {
      parsed = data;
    }
    onEvent({ id: id, event: event, data: parsed });
  }

  return {
    feed: function (chunk) {
      buffer += chunk;
      var idx;
      while ((idx = buffer.indexOf('\n\n')) !== -1) {
        var frame = buffer.substring(0, idx);
        buffer = buffer.substring(idx + 2);
        flushFrame(frame);
      }
    },
    close: function () {
      if (buffer.length > 0) flushFrame(buffer);
      buffer = '';
    },
  };
}
